import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  PassThroughAdapterdbgnfuhbpbsv as PassThroughAdapter,
  get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter,
  get_FloatAdapter8hkphxq3v57l as get_FloatAdapter,
  get_LongAdapter1acs38m0a7icu as get_LongAdapter,
  get_DoubleAdapter3vjvxl0ttbawu as get_DoubleAdapter,
  get_IntAdapter2kzerdn7hhunh as get_IntAdapter,
  get_BooleanAdapterefxw889yjdy4 as get_BooleanAdapter,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_UploadAdapter1jp2f4wtvjtde as get_UploadAdapter,
} from './Adapters.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from './ExecutionContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {
      constructor() {
        Key_instance = this;
        this.v45_1 = (new (Builder())()).n37();
        this.w45_1 = (new (Builder())()).c46(true).n37();
      }
    }
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  if (Key_instance === VOID)
    new (Key())();
  return Key_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.x45_1 = LinkedHashMap().gc();
        this.y45_1 = false;
        this.z45_1 = null;
        this.a46_1 = null;
        this.b46_1 = null;
      }
      d46(falseVariables) {
        // Inline function 'kotlin.apply' call
        this.z45_1 = falseVariables;
        return this;
      }
      e46(deferredFragmentIdentifiers) {
        // Inline function 'kotlin.apply' call
        this.a46_1 = deferredFragmentIdentifiers;
        return this;
      }
      f44(errors) {
        // Inline function 'kotlin.apply' call
        this.b46_1 = errors;
        return this;
      }
      f46(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.x45_1.e5(customScalarAdapters.k46_1);
        return this;
      }
      c46(unsafe) {
        // Inline function 'kotlin.apply' call
        this.y45_1 = unsafe;
        return this;
      }
      f5() {
        this.x45_1.f5();
      }
      n37() {
        return new (CustomScalarAdapters())(this.x45_1, this.z45_1, this.a46_1, this.b46_1, this.y45_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CustomScalarAdaptersClass;
function CustomScalarAdapters() {
  if (CustomScalarAdaptersClass === VOID) {
    class $ {
      constructor(customScalarAdapters, falseVariables, deferredFragmentIdentifiers, errors, unsafe) {
        Key_getInstance();
        this.g46_1 = falseVariables;
        this.h46_1 = deferredFragmentIdentifiers;
        this.i46_1 = errors;
        this.j46_1 = unsafe;
        this.k46_1 = customScalarAdapters;
      }
      l46(customScalar) {
        var tmp;
        if (!(this.k46_1.z4(customScalar.s45_1) == null)) {
          tmp = this.k46_1.z4(customScalar.s45_1);
        } else if (customScalar.r45_1 === 'com.apollographql.apollo.api.Upload') {
          tmp = get_UploadAdapter();
        } else if (listOf(['kotlin.String', 'java.lang.String']).y2(customScalar.r45_1)) {
          tmp = get_StringAdapter();
        } else if (listOf(['kotlin.Boolean', 'java.lang.Boolean']).y2(customScalar.r45_1)) {
          tmp = get_BooleanAdapter();
        } else if (listOf(['kotlin.Int', 'java.lang.Int']).y2(customScalar.r45_1)) {
          tmp = get_IntAdapter();
        } else if (listOf(['kotlin.Double', 'java.lang.Double']).y2(customScalar.r45_1)) {
          tmp = get_DoubleAdapter();
        } else if (listOf(['kotlin.Long', 'java.lang.Long']).y2(customScalar.r45_1)) {
          tmp = get_LongAdapter();
        } else if (listOf(['kotlin.Float', 'java.lang.Float']).y2(customScalar.r45_1)) {
          tmp = get_FloatAdapter();
        } else if (listOf(['kotlin.Any', 'java.lang.Object']).y2(customScalar.r45_1)) {
          tmp = get_AnyAdapter();
        } else if (this.j46_1) {
          tmp = new (PassThroughAdapter())();
        } else {
          var message = "Can't map GraphQL type: `" + customScalar.s45_1 + '` to: `' + customScalar.r45_1 + '`. Did you forget to add a scalar Adapter?';
          throw IllegalStateException().o(toString(message));
        }
        var tmp_0 = tmp;
        return (!(tmp_0 == null) ? isInterface(tmp_0, Adapter()) : false) ? tmp_0 : THROW_CCE();
      }
      r3() {
        return Key_getInstance();
      }
      q43() {
        return (new (Builder())()).f46(this).d46(this.g46_1).e46(this.h46_1);
      }
    }
    protoOf($).m46 = get;
    protoOf($).n46 = fold;
    protoOf($).o46 = minusKey;
    protoOf($).d44 = plus;
    initMetadataForClass($, 'CustomScalarAdapters', VOID, VOID, [Element()]);
    CustomScalarAdaptersClass = $;
  }
  return CustomScalarAdaptersClass;
}
//region block: exports
export {
  Builder as Builder4ra56zvvku0a,
  Key_getInstance as Key_getInstance30q5r2nw695ls,
};
//endregion

//# sourceMappingURL=CustomScalarAdapters.mjs.map
